import React, { useContext } from 'react';

import Masonry from 'react-masonry-css'

import ShowAll from './ShowAll'
import Card from './Card'
import { useShowAll } from '../../hooks/useShowAll'


const breakpointColumnsObj = {
  default: 2,
  1100: 2,
  700: 1,
  500: 1
};

export default function(props) {
  const [messages, showAll, nextMessage, countLeft] = useShowAll(props.corpus, 3)
  const cards = messages.map(example => <Card textClassName={"text-black"} showLabels={false} {...example} />)
  if (nextMessage) {
    cards.push(<ShowAll onClick={showAll} nextMessage={nextMessage} countLeft={countLeft} />)
  }
  return (
    <Masonry 
      breakpointCols={breakpointColumnsObj}
      className="django-doctor-masonry-grid"
      columnClassName="django-doctor-masonry-grid_column pl-md-3 ml-3">
      { cards }
    </Masonry>
  )
}

